export default function PrivacyPolicyPage({
  hideTopSpace,
}: {
  hideTopSpace: boolean;
}) {
  return (
    <div
      className={`mx-auto flex max-w-[1040px] flex-col py-10 text-product2-content-primary ${hideTopSpace ? 'md:mt-0' : 'md:mt-[100px]'} mb-0 break-words px-[20px] pb-[50px] ${hideTopSpace ? 'mt-0' : 'mt-[50px]'}`}
    >
      <h1
        id="privacy-policy"
        className="text-5xl font-bold text-product2-content-primary"
      >
        Privacy Policy
      </h1>

      <div id="fst" className="fex mt-10 flex-col space-y-4">
        <style jsx>
          {`
            h2 {
              margin-top: 40px !important;
            }
          `}
        </style>
        <h2 className="text-3xl font-bold">1. General</h2>
        <h3 className="text-xl font-semibold">1.1</h3>
        <p>
          This privacy policy (&quot;Policy&quot;) provides transparency about
          how Mimo GmbH, Währinger Straße 2-4/48, Vienna, Austria
          (&quot;Mimo,&quot; &quot;us,&quot; or &quot;we&quot;) collects,
          receives, processes, uses, discloses, or shares your personal data and
          device information (&quot;Information&quot;). When you use our apps,
          websites, or other services provided by Mimo (together
          &quot;Services&quot;) or otherwise form a relationship with us, we may
          obtain Information.
        </p>
        <h3 className="text-xl font-semibold">1.2</h3>
        <p>
          We want to show you that we handle your Information in compliance with
          the General Data Protection Regulation (&quot;GDPR&quot;), the
          Austrian Data Protection Act (&quot;DSG&quot;), and – when it comes to
          device information – the Austrian Telecommunication Act
          (&quot;TKG&quot;). To understand more about the Policy, access your
          Information, ask questions about our privacy practices, or issue a
          complaint, contact us at privacy@mimo.org.
        </p>
        <h3 className="text-xl font-semibold">1.3</h3>
        <p>
          We may update our Policy to reflect changes to our practices. If we do
          this and the changes are material (this means a change of purpose of
          processing, of the controller, or in the modalities for exercising
          data subjects&apos; rights), we will post a notice that we intend to
          update this Policy on the websites at least 14 days before the update
          is getting into effect and will inform you via email address lastly
          notified by you. Any update to this Policy will become effective at
          the date declared there.
        </p>

        <h2 className="text-3xl font-bold">2. Websites and Apps</h2>
        <h3 className="text-xl font-semibold">2.1</h3>
        <p>
          When you visit the websites or use our apps, we process only
          Information that your device and/or browser communicates to our
          servers. We collect the following Information, which is necessary to
          display the Website correctly and guarantee the necessary stability
          and safety:
        </p>
        <ol className="mt-4 list-[lower-alpha] pl-5">
          <li>IP address;</li>
          <li>date and time stamp;</li>
          <li>time difference to GMT;</li>
          <li>requested site;</li>
          <li>access status/HTTP status code;</li>
          <li>transmitted data volume;</li>
          <li>site from which the request was sent;</li>
          <li>browser;</li>
          <li>operating system and interface; and</li>
          <li>language and version of the browser.</li>
        </ol>
        <h3 className="text-xl font-semibold">2.2</h3>
        <p>
          When using our apps, we process IP address, date, and time stamp, the
          time difference to GMT, phone manufacturer and model, operating system
          and operating system version, browser and browser version, and
          language.
        </p>
        <h3 className="text-xl font-semibold">2.3</h3>
        <p>
          The provision of this information is necessary for the use of our
          Services. If you do not provide this information, you cannot use our
          Services.
        </p>
        <h3 className="text-xl font-semibold">2.4</h3>
        <p>
          This information will be deleted automatically after we process your
          IP address to identify the country from which you are using our
          websites or apps.
        </p>
        <h3 className="text-xl font-semibold">2.5</h3>
        <p>
          Furthermore, our websites and apps use cookies and other technologies
          to process information from your device (&quot;Cookies&quot;). For
          details, please review our cookie list: mimo.org/cookies.
        </p>
        <h3 className="text-xl font-semibold">2.6</h3>
        <p>
          We use data processors to provide our websites and apps and for
          analytics. Your data is transferred to the following third countries:
          the United Kingdom (adequacy decision) and the United States of
          America (adequacy decision).
        </p>

        <h2 className="text-3xl font-bold">3. Registration</h2>
        <h3 className="text-xl font-semibold">3.1</h3>
        <p>
          Irrespective of your choice of registration, we process your email
          address and full name (&quot;Master Data&quot;).
        </p>
        <ol className="mt-4 list-[lower-alpha] pl-5">
          <li>
            If you use Apple single sign-on for registration, we collect Master
            Data unless hidden, but language, country, time zone, device,
            browser and IP address.
          </li>
          <li>
            If you use Google single sign-on for registration, we collect Master
            Data, language, country, time zone, device, browser and IP address.
          </li>
          <li>
            If you use Facebook single sign-on for registration, we collect
            Master Data, language, country, time zone, device, browser and IP
            address.
          </li>
        </ol>
        <h3 className="text-xl font-semibold">3.2</h3>
        <p>
          Processing of Master Data is based on the necessity for entering into
          and the performance of the contract between you and Mimo. Processing
          for registration in relation to single sign-on by Apple, Google, or
          Facebook is based on your consent. The provision of this information
          is necessary for the use of our Services. If you do not provide this
          information, you cannot use our Services.
        </p>
        <h3 className="text-xl font-semibold">3.3</h3>
        <p>
          We store your Information as long as you have an account. If you
          decide to delete your account, we may continue to process them for the
          fulfilment of legal obligations. Therefore, the Austrian
          administration requires us to keep records and supporting documents
          records for seven years (§ 132 BAO).
        </p>
        <h3 className="text-xl font-semibold">3.4</h3>
        <p>
          To manage your account and provide our Services, we use data
          processors. Your data is transferred to the following third countries:
          the United Kingdom (adequacy decision) and the United States of
          America (adequacy decision).
        </p>

        <h2 className="text-3xl font-bold">4. Purchase of Services</h2>
        <h3 className="text-xl font-semibold">4.1</h3>
        <p>
          When you purchase Services, we process your country, currency, and
          Mimo account information. If you are using Stripe for payment, we
          process your credit card information.
        </p>
        <h3 className="text-xl font-semibold">4.2</h3>
        <p>
          This Information is processed on the necessity for entering into and
          the performance of the contract between you and Mimo. The provision of
          this information is necessary for the use of our Services. If you do
          not provide this information, you cannot use our Services.
        </p>
        <h3 className="text-xl font-semibold">4.3</h3>
        <p>
          Information in relation to the purchase of Services will be stored
          until the Services are declined and, after that, for seven years due
          to our legal obligation to retain business documentation (§ 132 BAO).
        </p>
        <h3 className="text-xl font-semibold">4.4</h3>
        <p>
          We use an external account service. Furthermore, we manage your
          purchase of the Services by using data processors. Your data is
          transferred to the following third countries: the United Kingdom
          (adequacy decision) and the United States of America (adequacy
          decision).
        </p>

        <h2 className="text-3xl font-bold">5. Use of Services and Support</h2>
        <h3 className="text-xl font-semibold">5.1</h3>
        <p>
          When you use the Services, we process Information that you launched,
          signed up, logged into, or logged out of the Services, your purchases
          within Services, the tracks, courses, and exercises you completed, and
          how you navigate the Services (&quot;Usage Data&quot;).
        </p>
        <h3 className="text-xl font-semibold">5.2</h3>
        <p>
          When you request support, we process your email address, first name,
          last name, Mimo account information, and data from Mixpanel
          (&quot;Support Information&quot;).
        </p>
        <h3 className="text-xl font-semibold">5.3</h3>
        <p>
          Processing of Usage Data and Support Information is based on the
          necessity for the performance of the contract between you and Mimo.
          The provision of this information is necessary for the use of our
          Services. If you do not provide this information, you cannot use our
          Services.
        </p>
        <h3 className="text-xl font-semibold">5.4</h3>
        <p>
          Usage Data are processed as long as you use our Services. Support
          Information is deleted 24 months after a support request is closed.
        </p>
        <h3 className="text-xl font-semibold">5.5</h3>
        <p>
          To provide our Services and support, we use data processors. Your data
          is transferred to the following third countries: the United Kingdom
          (adequacy decision) and the United States of America (adequacy
          decision).
        </p>

        <h2 className="text-3xl font-bold">6. Safety and Security</h2>
        <h3 className="text-xl font-semibold">6.1</h3>
        <p>
          To ensure the safety and security of our Services, we use Cloudflare
          and process your IP address. Your data is transferred primarily to the
          United States of America (adequacy decision). However, to facilitate
          Cloudflare&apos;s global operations, data may be transferred and
          accessed from around the world, including from other countries in
          which Cloudflare has operations for the purposes described in their
          privacy policy.
        </p>
        <h3 className="text-xl font-semibold">6.2</h3>
        <p>
          This processing is in our legitimate interest to ensure the safety and
          security of our Services. Such Information will be stored for up to 24
          hours and deleted afterward.
        </p>
        <h3 className="text-xl font-semibold">6.3</h3>
        <p>
          The provision of this information is necessary for the use of our
          Services. If you do not provide this information, you cannot use our
          Services.
        </p>

        <h2 className="text-3xl font-bold">7. Marketing and Personalization</h2>
        <h3 className="text-xl font-semibold">7.1</h3>
        <p>
          For marketing purposes we provide emails and push notifications on our
          Services (&quot;Marketing Data&quot;). Therefore, we process to
          provide
        </p>
        <ol className="mt-4 list-[lower-alpha] pl-5">
          <li>
            emails: Experience Data (see below) and email-related behavior (open
            rates, click-through rates).
          </li>
          <li>
            push notifications: Experience Data (see below) and
            notification-related behavior (open rates).
          </li>
        </ol>
        <h3 className="text-xl font-semibold">7.2</h3>
        <p>
          We personalize our Service. That means we use data such as course
          completion and exercise mistakes to recommend practice lessons.
          Therefore, we process the following Information: motives, experience,
          language, progress (course completion, mistakes), usage (e.g., streak
          length), and Mimo account information (e.g., subscription status)
          (&quot;Experience Data&quot;).
        </p>
        <h3 className="text-xl font-semibold">7.3</h3>
        <p>
          Processing of Marketing Data is based on your consent. You may
          withdraw consent at any time in the future; further information is
          available in #9. The provision of this information is not necessary
          for the use of our Services. You can use our Services even if you do
          not provide this information.
        </p>
        <h3 className="text-xl font-semibold">7.4</h3>
        <p>
          Processing of Experience Data is necessary for the performance of the
          contract between you and Mimo. The provision of this information is
          necessary for the use of our Services. If you do not provide this
          information, you cannot use our Services.
        </p>
        <h3 className="text-xl font-semibold">7.5</h3>
        <p>
          Processing for marketing and personalization will end when you revoke
          your consent. Experience Data will be processed as long as you use our
          Services.
        </p>
        <h3 className="text-xl font-semibold">7.6</h3>
        <p>
          For these purposes, we use data processors. Your data is transferred
          to the following third countries: the United Kingdom (adequacy
          decision) and the United States of America (adequacy decision).
        </p>

        <h2 className="text-3xl font-bold">8. Research and Development</h2>
        <h3 className="text-xl font-semibold">8.1</h3>
        <p>
          Mimo conducts research and development of its Services on an ongoing
          basis. This means we may roll out product features experimentally and
          measure their impact on different metrics.
        </p>
        <h3 className="text-xl font-semibold">8.2</h3>
        <p>
          Therefore, we process Information as follows: Motives, experience,
          language, progress (course completion, mistakes), usage (e.g., streak
          length), and Mimo account information (e.g., subscription status).
        </p>
        <h3 className="text-xl font-semibold">8.3</h3>
        <p>
          Where we retain information for Service improvement and development
          during your usage, we take steps to eliminate information that
          directly or indirectly identifies you. We only use the information to
          uncover collective insights about using our Services, not to analyse
          personal details about you.
        </p>
        <h3 className="text-xl font-semibold">8.4</h3>
        <p>
          Processing is based on our legitimate interests in conducting research
          and product development. Therefore, we use data processors. Your data
          is transferred to the following third countries: the United Kingdom
          (adequacy decision) and the United States of America (adequacy
          decision).
        </p>

        <h2 className="text-3xl font-bold">9. Rights of the Data Subject</h2>
        <h3 className="text-xl font-semibold">9.1</h3>
        <p>
          To exercise your rights, you may send a request via email to
          privacy@mimo.org or via letter mail to the address provided in section
          1.1.
        </p>
        <h3 className="text-xl font-semibold">9.2</h3>
        <p>
          You can withdraw your consent for future data processing at any time.
          However, this does not affect the lawfulness of data processing based
          on the previous consent.
        </p>
        <h3 className="text-xl font-semibold">9.3</h3>
        <p>
          You have the right to request access to rectification or erasure of
          Information, restriction of processing or object to processing, as
          well as the right to data portability.
        </p>
        <h3 className="text-xl font-semibold">9.4</h3>
        <p>
          You have the right to lodge a complaint with a supervisory authority.
        </p>

        <p className="!mt-10 text-sm">
          This privacy policy was last modified on September 25, 2024, and took
          effect on October 3, 2024.
        </p>
      </div>
    </div>
  );
}
